import React, { useState, useMemo } from 'react'
import AdxDropdown from 'components/custom/AdxDropdown'
import AdxInput from 'components/custom/AdxInput'
import ListSubheader from '@mui/material/ListSubheader'
import InputAdornment from '@mui/material/InputAdornment'
import SearchIcon from '@mui/icons-material/Search'
import { useDebouncedEffect } from 'services/hooks/useDebouncedEffect'
import { Box } from '@mui/material'

export const optionsWithImg = [
  {
    id: 1,
    value: 1,
    name: 'Azizi Shaharuddin',
    role: 'Software Engineer',
    img: null,
  },
  {
    id: 2,
    value: 2,
    name: 'Amaluddin Asyraf',
    role: 'Software Engineer',
    img: null,
  },
  {
    id: 3,
    value: 3,
    name: 'Tg. Zhafrul',
    role: 'Software Engineer',
    img: null,
  },
  {
    id: 4,
    value: 4,
    name: 'Tg. Zhafri',
    role: 'Finance',
    img: null,
  },
  {
    id: 5,
    value: 5,
    name: 'Abg Long',
    role: 'Admin',
    img: null,
  },
]

const AdxMultiselectWFilter = ({
  allOptions,
  setOptions,
  filters = ['name', 'title'],
  value,
  onChange,
  sx,
  children,
  ...rest
}) => {
  // Props:
  // 1. allOptions: 'array'. Array of all raw options to be passed into the dropdown.
  // 2. setOptions: 'function'. The function to set the manipulated array of options.
  // 3. filters: array['string']. An array of string based on object keys of the dropdown options for the filter function. This will allow multiple property search of the elements in the dropdown options.
  // 4. value: 'string'. The selected value of the dropdown.
  // 5. onChange: 'function'. The function to set the selected value of the dropdown.

  const [searchFilterValue, setSearchFilterValue] = useState('')

  const handleChangeSearchFilter = (event) => {
    event.preventDefault()
    setSearchFilterValue(event.target.value)
  }

  const displayedOptions = useMemo(() => {
    return allOptions?.filter((option) => {
      for (let key in filters) {
        if (
          option[filters[key]] &&
          option[filters[key]].toString().toLowerCase().indexOf(searchFilterValue.toLowerCase()) >
            -1
        ) {
          return true
        }
      }
      return false
    })
  }, [searchFilterValue, allOptions]) // eslint-disable-line react-hooks/exhaustive-deps

  useDebouncedEffect(
    () => {
      setOptions(displayedOptions)
    },
    [displayedOptions],
    200
  )

  return (
    <>
      <AdxDropdown
        onClose={() => setSearchFilterValue('')}
        value={value}
        onChange={onChange}
        sx={{ ...sx }}
        {...rest}
      >
        {/* Filter search bar here */}
        <ListSubheader sx={{ p: 2 }}>
          <AdxInput
            value={searchFilterValue}
            onChange={handleChangeSearchFilter}
            onKeyDown={(e) => {
              if (e.key !== 'Escape') {
                // Prevents autoselecting item while typing (default Select behaviour)
                e.stopPropagation()
              }
            }}
            autoFocus
            size="standard"
            placeholder="Search"
            sx={{
              backgroundColor: 'gray-background.main',
              outlineColor: 'white',
            }}
            startAdornment={
              <InputAdornment position="start">
                <SearchIcon sx={{ mx: 1 }} />
              </InputAdornment>
            }
          />
        </ListSubheader>
        {children}
      </AdxDropdown>
    </>
  )
}

export default AdxMultiselectWFilter
